import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/shared/Reveal";
import { useSEO } from "@/lib/seo";

export default function NotFound() {
  useSEO({
    title: "Page Not Found",
    description: "The page you're looking for doesn't exist. Explore Vikas Rolls products, industries and technical services.",
  });

  return (
    <section className="relative min-h-[85vh] flex items-center bg-ink bg-blueprint">
      <div className="max-w-4xl mx-auto px-5 md:px-10 py-40 w-full">
        <Reveal>
          <p className="font-mono-tech text-xs uppercase tracking-[0.3em] text-amber-brand mb-6">Error — off the roll path</p>
          <h1 className="font-display font-black tracking-tight text-[26vw] sm:text-[10rem] leading-[0.85] text-transparent select-none" style={{ WebkitTextStroke: "2px #3a3e42" }}>
            404
          </h1>
          <h2 className="font-display font-bold text-2xl md:text-3xl text-steel-light mt-6 mb-4">This page has been decommissioned.</h2>
          <p className="text-steel text-base md:text-lg max-w-xl mb-10">
            The address you followed doesn't exist on this site. Head back to the shop floor, or jump straight to what you need.
          </p>
          <div className="flex flex-wrap gap-4">
            <Link to="/" data-testid="notfound-home-button" className="group inline-flex items-center gap-3 bg-amber-brand text-ink font-display font-bold px-8 py-4 hover:bg-steel-light">
              Back to Home
              <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
            <Link to="/products" data-testid="notfound-products-link" className="inline-flex items-center gap-3 border border-line text-steel-light font-display font-bold px-8 py-4 hover:border-amber-brand hover:text-amber-brand">
              View Products
            </Link>
            <Link to="/contact" data-testid="notfound-contact-link" className="inline-flex items-center gap-3 border border-line text-steel-light font-display font-bold px-8 py-4 hover:border-amber-brand hover:text-amber-brand">
              Contact Us
            </Link>
          </div>
        </Reveal>
      </div>
      <div className="absolute bottom-0 inset-x-0 ticks opacity-50" aria-hidden="true" />
    </section>
  );
}
